import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { EmpathySection } from './components/EmpathySection';
import { ProblemSection } from './components/ProblemSection';
import { MechanismSection } from './components/MechanismSection';
import { ProductRevealSection } from './components/ProductRevealSection';
import { WhatsInsideSection } from './components/WhatsInsideSection';
import { WhoItsForSection } from './components/WhoItsForSection';
import { FounderSection } from './components/FounderSection';
import { DifferenceSection } from './components/DifferenceSection';
import { OfferSection } from './components/OfferSection';
import { FAQSection } from './components/FAQSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    try {
      if (typeof window === 'undefined') return;
      if ((window as any).fbq) return;
      const n: any = (window as any).fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!(window as any)._fbq) (window as any)._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = document.getElementsByTagName('script')[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        document.head.appendChild(t);
      }
      ;
      (window as any).fbq('init', '884777681203338');
      (window as any).fbq('track', 'PageView');
    } catch (e) {
      // Meta Pixel failed to initialize — non-critical, continue rendering
    }
  }, []);
  return <div className="min-h-screen bg-bg text-ink font-inter selection:bg-brand selection:text-black" data-id="element-0">
      <HeroSection data-id="element-1" />
      <EmpathySection data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <MechanismSection data-id="element-4" />
      <ProductRevealSection data-id="element-5" />
      <WhatsInsideSection data-id="element-6" />
      <WhoItsForSection data-id="element-7" />
      <FounderSection data-id="element-8" />
      <DifferenceSection data-id="element-9" />
      <OfferSection data-id="element-10" />
      <FAQSection data-id="element-11" />
      <FinalCtaSection data-id="element-12" />
      <Footer data-id="element-13" />
    </div>;
}